module.exports = __webpack_public_path__ + "img/paypal_logo.73f85087.svg";